import { render, staticRenderFns } from "./AddonProductSkeleton.vue?vue&type=template&id=20f28167&scoped=true&"
var script = {}
import style0 from "./AddonProductSkeleton.vue?vue&type=style&index=0&id=20f28167&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f28167",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\swag\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f28167')) {
      api.createRecord('20f28167', component.options)
    } else {
      api.reload('20f28167', component.options)
    }
    module.hot.accept("./AddonProductSkeleton.vue?vue&type=template&id=20f28167&scoped=true&", function () {
      api.rerender('20f28167', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Swag/components/Skeletons/AddonProductSkeleton.vue"
export default component.exports